import { preenchidos, valorParaMostrar } from '../../lib/campos';
import React, { useState } from 'react';
import { DateBadge, Modal } from '../../components/base';

import { INTERACTION_TYPES, LEAD_ORIGINS, LOSS_REASON_LABELS, STAGES, WA_ICON, WA_TEMPLATES } from '../../lib/constantes';
import { CopiarContato } from './CopiarContato';
import { JornadaLead } from './JornadaLead';
import { rotuloEmpresa } from '../../lib/empresas';
import { calcContractTotal, fmt, fmtDateOnly, fmtWhatsApp, getDateStatus, getRecLabel, getRecMonths, normalizeUrl, renderWaTemplate, waLink } from '../../lib/formato';

function LeadDetailModal({ lead, onClose, onEdit, onDelete, onStageChange, company = '', camposCustom = [], onAddTask, onToggleTask, onDeleteTask, onAddInteraction, onEditInteraction, onDeleteInteraction, onAddTimelineNote, onEditTimelineNote, onDeleteTimelineNote, onSaveDeal, onMove, moveTargets, isAdmin, contatos = [], leads = [], onOpenLead }) {
  const [modalTab, setModalTab] = React.useState('info');
  const [showMoveMenu, setShowMoveMenu] = React.useState(false);
  const [moving, setMoving] = React.useState(false);
  if (!lead) return null;
  const ds = (lead.next_contact_date && !['fechado','perdido'].includes(lead.stage)) ? getDateStatus(lead.next_contact_date) : null;
  const stageMeta = STAGES.find(s=>s.key===lead.stage) || (lead.stage==='prospeccao' ? {label:'Backlog',color:'bg-slate-100 border-slate-300'} : {label:lead.stage||'—',color:'bg-gray-100 border-gray-200'});
  const wa = fmtWhatsApp(lead.contact_phone);
  const hasStatus = !!(lead.interactions?.length || lead.timeline?.length || lead.deal?.notes || lead.deal?.contract_value);

  return <Modal title={lead.company_name} onClose={onClose} wide>
    {/* Alerta de data */}
    {ds && <div className={`flex items-center gap-2 rounded-xl px-4 py-2.5 mb-4 ${ds.cls}`}>
      <span className="text-lg">{ds.status==='overdue'?'⚠️':ds.status==='today'?'🔔':'📅'}</span>
      <span className="text-sm font-medium">Próxima abordagem: {fmtDateOnly(lead.next_contact_date)}{Number(lead.followup_days) > 0 ? ` 🔁 a cada ${lead.followup_days} dias` : ''}</span>
      <DateBadge dateStr={lead.next_contact_date} size="lg" />
    </div>}

    {/* Contato e os outros negócios dele */}
    {(() => {
      const contato = contatos.find(c => c.id === lead.contact_id);
      if (!contato) return null;
      const outros = leads.filter(l => l.contact_id === lead.contact_id && l.id !== lead.id);
      if (!outros.length && !contato.incompleto) return null;
      return (
        <div className="rounded-2xl px-4 py-3 mb-4 bg-black/[0.03] border border-black/[0.05]">
          <div className="flex items-center gap-2 flex-wrap">
            <span aria-hidden="true">👤</span>
            <span className="text-sm font-semibold text-gray-800">{contato.nome}</span>
            {contato.email && <span className="t-caption-2 text-gray-400">{contato.email}</span>}
            {contato.incompleto && <span className="t-caption-2 bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded-full">sem e-mail nem telefone</span>}
          </div>
          {outros.length > 0 && (
            <>
              <p className="t-caption-2 text-gray-400 mt-2 mb-1.5">
                Também tem {outros.length} outra{outros.length > 1 ? 's' : ''} negociação{outros.length > 1 ? 'ões' : ''}:
              </p>
              <div className="space-y-1">
                {outros.map(o => {
                  const ganho = o.stage === 'fechado', perda = o.stage === 'perdido';
                  return (
                    <div key={o.id}
                      onClick={() => onOpenLead && onOpenLead(o)}
                      className="flex items-center justify-between gap-2 bg-white rounded-xl px-3 py-1.5 cursor-pointer hover:bg-black/[0.03] transition-colors">
                      <span className="text-xs text-gray-700 truncate flex-1">{o.company_name}</span>
                      {o.value > 0 && <span className={`text-xs font-semibold ${ganho ? 'text-green-700' : 'text-gray-500'}`}>{fmt(Number(o.value))}</span>}
                      <span className={`t-caption-2 px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
                        ganho ? 'bg-green-100 text-green-700' : perda ? 'bg-red-100 text-red-600' : 'bg-blue-50 text-blue-600'}`}>
                        {STAGES.find(x => x.key === o.stage)?.label || 'Backlog'}
                      </span>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
      );
    })()}

    {/* Proposta em destaque */}
    {normalizeUrl(lead.proposal_url) && <a
      href={normalizeUrl(lead.proposal_url)} target="_blank" rel="noopener noreferrer"
      aria-label={`Abrir proposta de ${lead.company_name} em nova guia`}
      className="flex items-center gap-3 rounded-2xl px-4 py-3 mb-4 bg-indigo-50 border border-indigo-200 text-indigo-700 hover:bg-indigo-100 hover:border-indigo-300 transition-colors">
      <span aria-hidden="true" className="text-lg">📄</span>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold">Ver proposta</p>
        <p className="t-caption-2 text-indigo-400 truncate">{normalizeUrl(lead.proposal_url).replace(/^https?:\/\//,'')}</p>
      </div>
      <span aria-hidden="true" className="text-sm opacity-60 flex-shrink-0">↗</span>
    </a>}

    {/* Tab switcher */}
    <div className="flex gap-1 mb-5 bg-black/[0.05] rounded-full p-1">
      <button onClick={()=>setModalTab('info')}
        className={`flex-1 text-sm py-1.5 rounded-full font-medium transition-all ${modalTab==='info'?'bg-white text-gray-900 shadow-sm':'text-gray-400 hover:text-gray-600'}`}>
        📋 Informações
      </button>
      <button onClick={()=>setModalTab('status')}
        className={`flex-1 text-sm py-1.5 rounded-full font-medium transition-all relative ${modalTab==='status'?'bg-white text-gray-900 shadow-sm':'text-gray-400 hover:text-gray-600'}`}>
        🔄 Atividade
        {hasStatus && modalTab!=='status' && <span className="absolute top-1.5 right-3 w-2 h-2 bg-blue-500 rounded-full"/>}
      </button>
    </div>

    {/* ── ABA INFORMAÇÕES ── */}
    {modalTab==='info' && <>
      <div className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm mb-4">
        <div><span className="text-gray-400">Contato:</span> <span className="font-medium">{lead.contact_name||'—'}</span></div>
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-gray-400">Telefone:</span>
          <span className="font-medium">{lead.contact_phone||'—'}</span>
          {wa && <WhatsAppMenu wa={wa} lead={lead} company={company} />}
          <CopiarContato lead={lead} company={company} />
        </div>
        <div><span className="text-gray-400">E-mail:</span> <span className="font-medium">{lead.contact_email||'—'}</span></div>
        <div className="flex items-center gap-1.5">
          <span className="text-gray-400">Site:</span>
          {lead.site
            ? <a href={lead.site} target="_blank" rel="noopener noreferrer"
                 className="font-medium text-blue-700 hover:underline truncate" title={lead.site}>
                {String(lead.site).replace(/^https?:\/\//i, '').replace(/\/$/, '')}
              </a>
            : <span className="font-medium">—</span>}
        </div>
        <div className="flex items-center gap-1.5">
          <span className="text-gray-400">Instagram:</span>
          {lead.instagram
            ? <a href={`https://instagram.com/${lead.instagram}`} target="_blank" rel="noopener noreferrer"
                 className="font-medium text-blue-700 hover:underline truncate">@{lead.instagram}</a>
            : <span className="font-medium">—</span>}
        </div>
        <div><span className="text-gray-400">Valor mensal:</span> <span className="font-medium text-green-700">{fmt(lead.value)}</span></div>
        {lead.variable_rate>0 && <div><span className="text-gray-400">% Variável:</span> <span className="font-semibold text-indigo-700">+{lead.variable_rate}% sobre faturamento</span></div>}
        <div className="flex items-center gap-2"><span className="text-gray-400">Etapa:</span>
          {isAdmin && onStageChange
            ? <select value={lead.stage} onChange={e=>onStageChange(lead.id, e.target.value)} title="Mudar etapa sem abrir o formulário"
                className={`font-medium px-2 py-0.5 rounded-full text-xs border cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-300 ${stageMeta?.color}`}>
                {STAGES.map(s=><option key={s.key} value={s.key}>{s.label}</option>)}
              </select>
            : <span className={`font-medium px-2 py-0.5 rounded-full text-xs ${stageMeta?.color}`}>{stageMeta?.label}</span>}
        </div>
        <div><span className="text-gray-400">Criado:</span> <span className="font-medium">{lead.created_at ? new Date(lead.created_at).toLocaleDateString('pt-BR') : '—'}</span></div>
        {lead.seller_name && <div><span className="text-gray-400">Vendedor:</span> <span className="font-medium text-blue-700">👤 {lead.seller_name}</span></div>}
        {lead.service_type && <div><span className="text-gray-400">Serviço:</span> <span className="font-medium text-indigo-700">🎯 {lead.service_type}</span></div>}
        {lead.origem && (() => { const o = LEAD_ORIGINS.find(x=>x.key===lead.origem); return o ? <div><span className="text-gray-400">Origem:</span> <span className="font-medium text-amber-700">{o.emoji} {o.label}</span></div> : null; })()}
        {lead.recurrence && <div><span className="text-gray-400">Recorrência:</span> <span className="font-medium">🔁 {getRecLabel(lead.recurrence)}</span></div>}
        {lead.recurrence && lead.value>0 && (() => {
          const total = calcContractTotal(lead.value, lead.recurrence);
          const months = lead.recurrence!=='unica' ? getRecMonths(lead.recurrence) : null;
          return total !== (Number(lead.value)||0)
            ? <div className="col-span-2 bg-emerald-50 border border-emerald-200 rounded-xl px-3 py-2">
                <span className="text-xs text-emerald-500 font-semibold">Valor total do contrato</span>
                <div className="font-bold text-emerald-700 text-lg">{fmt(total)}</div>
                {months && <div className="text-xs text-emerald-500">{months}x {fmt(lead.value)}/mês</div>}
              </div>
            : null;
        })()}
      </div>
      {/* Campos desta empresa (roadmap #24) */}
      {preenchidos(camposCustom, lead).length > 0 && <div className="mb-4 grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
        {preenchidos(camposCustom, lead).map(({ campo, valor }) => <div key={campo.key}>
          <span className="text-gray-400">{campo.label}:</span>{' '}
          {campo.tipo === 'url'
            ? <a href={valor} target="_blank" rel="noopener noreferrer" className="font-medium text-blue-600 hover:underline">{String(valor).replace(/^https?:\/\//, '')}</a>
            : <span className="font-medium">{valorParaMostrar(campo, valor)}</span>}
        </div>)}
      </div>}

      {/* Jornada: de onde veio, antes de virar lead */}
      <JornadaLead jornada={lead._jornada} />

      {/* Motivo da Perda */}
      {['perdido','repescagem'].includes(lead.stage) && lead.loss_reason && (
        <div className="mb-4 bg-red-50 border border-red-200 rounded-xl px-4 py-2.5 flex items-center gap-2">
          <span className="text-lg">🔴</span>
          <div>
            <span className="text-xs text-red-400 font-semibold">Motivo da Perda</span>
            <p className="text-sm font-semibold text-red-700">{LOSS_REASON_LABELS[lead.loss_reason] || lead.loss_reason}</p>
          </div>
        </div>
      )}
      {/* Parceiros */}
      {lead.partners?.length > 0 && <div className="mb-4">
        <div className="text-xs text-gray-400 font-semibold mb-1.5">Parceiros</div>
        <div className="flex gap-2 flex-wrap">
          {lead.partners.map(p=>(
            <span key={p.id} className="bg-purple-50 text-purple-700 border border-purple-200 text-xs px-2 py-1 rounded-full">
              {p.name}{p.commission_rate>0?` · ${p.commission_rate}%`:''}
            </span>
          ))}
        </div>
      </div>}
      {/* Observações */}
      {lead.notes && <div className="mb-4 bg-gray-50 rounded-xl p-3 text-sm text-gray-700 whitespace-pre-wrap">{lead.notes}</div>}
    </>}

    {/* ── ABA ATIVIDADE ── */}
    {modalTab==='status' && <div className="space-y-5">
      <NextStepsBlock tasks={lead.tasks||[]} isAdmin={isAdmin} onAdd={t=>onAddTask && onAddTask(lead.id, t)} onToggle={id=>onToggleTask && onToggleTask(lead.id, id)} onDelete={id=>onDeleteTask && onDeleteTask(lead.id, id)} />
      <DealBoard deal={lead.deal||{}} onSave={data=>onSaveDeal(lead.id, data)} />
      <TimelineLog entries={lead.timeline||[]} onAdd={entry=>onAddTimelineNote(lead.id, entry)} onEdit={(id,data)=>onEditTimelineNote(lead.id,id,data)} onDelete={id=>onDeleteTimelineNote(lead.id,id)} />
      <InteractionLog interactions={lead.interactions||[]} onAdd={form=>onAddInteraction(lead.id,form)} onEdit={(id,data)=>onEditInteraction(lead.id,id,data)} onDelete={id=>onDeleteInteraction(lead.id,id)} />
    </div>}

    {/* Ações admin */}
    {isAdmin && <div className="mt-5 pt-4 border-t border-black/[0.06] space-y-2">
      <div className="flex gap-2">
        <button onClick={()=>onEdit(lead)} className="flex-1 bg-blue-50 text-blue-600 rounded-full py-2 text-sm font-semibold hover:bg-blue-100">✏️ Editar</button>
        {moveTargets?.length > 0 && <div className="relative">
          <button
            onClick={()=>setShowMoveMenu(o=>!o)}
            disabled={moving}
            className="flex items-center gap-1.5 bg-orange-50 text-orange-600 rounded-full py-2 px-4 text-sm font-semibold hover:bg-orange-100 transition-colors disabled:opacity-50"
          >
            {moving ? '...' : '📦 Mover'}
          </button>
          {showMoveMenu && <div className="absolute bottom-full right-0 mb-2 bg-white border border-gray-200 rounded-2xl shadow-xl p-2 min-w-[180px] z-50 animate-fade-in-up">
            <p className="t-caption-2 font-bold text-gray-400 px-2 py-1">Mover para...</p>
            {moveTargets.map(c => (
              <button key={c.id}
                onClick={async () => {
                  if (!confirm(`Mover "${lead.company_name}" para ${c.label}?`)) return;
                  setMoving(true); setShowMoveMenu(false);
                  await onMove(lead, c.id);
                  setMoving(false); onClose();
                }}
                className="w-full flex items-center gap-2 px-3 py-2 rounded-xl hover:bg-gray-50 text-sm text-gray-700 font-medium transition-colors"
              >
                <span className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${c.color==='red'?'bg-red-500':c.color==='orange'?'bg-orange-500':'bg-blue-500'}`}/>
                {c.label}
              </button>
            ))}
          </div>}
        </div>}
        <button onClick={()=>{if(confirm('Excluir este lead?')){onDelete(lead.id);onClose();}}} className="bg-red-50 text-red-500 rounded-full py-2 px-5 text-sm font-semibold hover:bg-red-100">🗑</button>
      </div>
    </div>}
  </Modal>;
}

// ─── KanbanCard ───────────────────────────────────────────

function DealBoard({ deal, onSave }) {
  const [editing, setEditing] = useState(false);
  const [f, setF] = useState({
    product:    deal?.product    || '',
    scope:      deal?.scope      || '',
    price:      deal?.price      || '',
    payment:    deal?.payment    || '',
    deadline:   deal?.deadline   || '',
    conditions: deal?.conditions || '',
    contract:   deal?.contract   || '',
  });
  const set = (k,v) => setF(p=>({...p,[k]:v}));
  const [saving, setSaving] = useState(false);

  const handleSave = async e => {
    e.preventDefault();
    setSaving(true);
    await onSave(f);
    setSaving(false);
    setEditing(false);
  };

  const inp = "apple-input w-full px-3 py-2 text-sm";
  const hasData = Object.values(deal||{}).some(v=>v);

  if (!editing) return <div>
    <div className="flex items-center justify-between mb-3">
      <h3 className="text-sm font-semibold text-gray-700">🤝 Negociação & Fechamento</h3>
      <button onClick={()=>setEditing(true)} className="text-xs bg-blue-50 text-blue-600 px-3 py-1 rounded-full hover:bg-blue-100">
        {hasData ? '✏️ Editar' : '+ Preencher'}
      </button>
    </div>
    {!hasData
      ? <p className="text-xs text-gray-400 text-center py-3 italic">Nenhuma informação de negociação registrada</p>
      : <div className="bg-blue-50 border border-blue-100 rounded-xl p-3 space-y-2">
          {deal.product    && <div className="flex gap-2 text-sm"><span className="text-gray-400 w-24 flex-shrink-0">Produto/Serv.:</span><span className="font-medium text-gray-800">{deal.product}</span></div>}
          {deal.scope      && <div className="flex gap-2 text-sm"><span className="text-gray-400 w-24 flex-shrink-0">Escopo:</span><span className="text-gray-700 break-words">{deal.scope}</span></div>}
          {deal.price      && <div className="flex gap-2 text-sm"><span className="text-gray-400 w-24 flex-shrink-0">Valor acertado:</span><span className="font-semibold text-green-700">{deal.price}</span></div>}
          {deal.payment    && <div className="flex gap-2 text-sm"><span className="text-gray-400 w-24 flex-shrink-0">Pagamento:</span><span className="text-gray-700">{deal.payment}</span></div>}
          {deal.deadline   && <div className="flex gap-2 text-sm"><span className="text-gray-400 w-24 flex-shrink-0">Prazo:</span><span className="text-gray-700">{deal.deadline}</span></div>}
          {deal.conditions && <div className="flex gap-2 text-sm"><span className="text-gray-400 w-24 flex-shrink-0">Condições:</span><span className="text-gray-700 break-words whitespace-pre-wrap">{deal.conditions}</span></div>}
          {deal.contract   && <div className="flex gap-2 text-sm"><span className="text-gray-400 w-24 flex-shrink-0">Contrato/Link:</span><span className="text-blue-600 break-all">{deal.contract}</span></div>}
        </div>}
  </div>;

  return <form onSubmit={handleSave} className="space-y-2">
    <div className="flex items-center justify-between mb-1">
      <h3 className="text-sm font-semibold text-gray-700">🤝 Negociação & Fechamento</h3>
    </div>
    <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 space-y-2">
      <input className={inp} placeholder="Produto / Serviço" value={f.product} onChange={e=>set('product',e.target.value)} />
      <textarea className={inp} rows={2} placeholder="Escopo do que foi acordado" value={f.scope} onChange={e=>set('scope',e.target.value)} />
      <div className="grid grid-cols-2 gap-2">
        <input className={inp} placeholder="Valor acertado (R$)" value={f.price} onChange={e=>set('price',e.target.value)} />
        <input className={inp} placeholder="Forma de pagamento" value={f.payment} onChange={e=>set('payment',e.target.value)} />
      </div>
      <div className="grid grid-cols-2 gap-2">
        <input className={inp} placeholder="Prazo de entrega" value={f.deadline} onChange={e=>set('deadline',e.target.value)} />
        <input className={inp} placeholder="Contrato / Link" value={f.contract} onChange={e=>set('contract',e.target.value)} />
      </div>
      <textarea className={inp} rows={2} placeholder="Condições especiais, garantias, etc." value={f.conditions} onChange={e=>set('conditions',e.target.value)} />
    </div>
    <div className="flex gap-2">
      <button type="submit" disabled={saving} className="bg-blue-500 text-white text-xs px-4 py-2 rounded-full hover:bg-blue-600 disabled:opacity-50 font-semibold">
        {saving ? 'Salvando...' : 'Salvar'}
      </button>
      <button type="button" onClick={()=>setEditing(false)} className="bg-gray-100 text-gray-600 text-xs px-4 py-2 rounded-full hover:bg-gray-200 font-semibold">Cancelar</button>
    </div>
  </form>;
}

// ─── TimelineLog (Linha do Tempo) ────────────────────────

function TimelineLog({ entries, onAdd, onEdit, onDelete }) {
  const today = new Date().toISOString().slice(0,10);
  const [text, setText] = useState('');
  const [date, setDate] = useState(today);
  const [adding, setAdding] = useState(false);
  const [saving, setSaving] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({ text:'', date:'' });

  const handleAdd = async e => {
    e.preventDefault();
    if (!text.trim()) return;
    setSaving(true);
    await onAdd({ text: text.trim(), date });
    setText(''); setDate(today); setAdding(false); setSaving(false);
  };

  const startEdit = entry => {
    setEditingId(entry.id);
    setEditForm({ text: entry.text||'', date: entry.date||entry.created_at?.slice(0,10)||today });
  };

  const handleSaveEdit = async e => {
    e.preventDefault();
    if (!editForm.text.trim()) return;
    await onEdit(editingId, { text: editForm.text.trim(), date: editForm.date });
    setEditingId(null);
  };

  const sorted = [...(entries||[])].sort((a,b) => (b.date||b.created_at||'') > (a.date||a.created_at||'') ? 1 : -1);

  return <div>
    <div className="flex items-center justify-between mb-3">
      <h3 className="text-sm font-semibold text-gray-700">📍 Linha do Tempo</h3>
      <button onClick={()=>setAdding(a=>!a)} className="text-xs bg-indigo-50 text-indigo-600 px-3 py-1 rounded-full hover:bg-indigo-100">+ Marco</button>
    </div>
    {adding && <form onSubmit={handleAdd} className="bg-indigo-50 rounded-2xl p-3 mb-4 space-y-2 border border-indigo-100">
      <input type="date" className="apple-input w-full px-2 py-1.5 text-sm"
        value={date} onChange={e=>setDate(e.target.value)} />
      <textarea required rows={2} className="apple-input w-full px-2 py-1.5 text-sm"
        placeholder="O que aconteceu?" value={text} onChange={e=>setText(e.target.value)} />
      <div className="flex gap-2">
        <button type="submit" disabled={saving} className="bg-indigo-500 text-white text-xs px-3 py-1.5 rounded-full hover:bg-indigo-600 disabled:opacity-50 font-semibold">
          {saving ? 'Salvando...' : 'Salvar marco'}
        </button>
        <button type="button" onClick={()=>setAdding(false)} className="bg-white text-gray-600 text-xs px-3 py-1.5 rounded-full hover:bg-gray-100 border font-semibold">Cancelar</button>
      </div>
    </form>}
    {sorted.length === 0
      ? <p className="text-xs text-gray-400 text-center py-4 italic">Nenhum marco registrado ainda</p>
      : <div className="relative">
          <div className="absolute left-3 top-2 bottom-2 w-0.5 bg-indigo-100 rounded-full" />
          <div className="space-y-3 max-h-72 overflow-y-auto pr-1">
            {sorted.map((e, idx) => (
              <div key={e.id||idx} className="flex gap-3 items-start pl-1 group">
                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-indigo-500 border-2 border-white shadow-sm flex items-center justify-center z-10 mt-0.5">
                  <div className="w-1.5 h-1.5 rounded-full bg-white" />
                </div>
                <div className="flex-1 bg-white rounded-xl border border-indigo-100 px-3 py-2 shadow-sm">
                  {editingId===e.id
                    ? <form onSubmit={handleSaveEdit} className="space-y-1.5">
                        <input type="date" className="w-full border rounded px-2 py-1 text-xs focus:outline-none focus:ring-2 focus:ring-indigo-400"
                          value={editForm.date} onChange={ev=>setEditForm(f=>({...f,date:ev.target.value}))} />
                        <textarea rows={2} className="w-full border rounded px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400"
                          value={editForm.text} onChange={ev=>setEditForm(f=>({...f,text:ev.target.value}))} />
                        <div className="flex gap-1">
                          <button type="submit" className="text-xs bg-indigo-600 text-white px-2 py-1 rounded hover:bg-indigo-700">Salvar</button>
                          <button type="button" onClick={()=>setEditingId(null)} className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded hover:bg-gray-200">Cancelar</button>
                        </div>
                      </form>
                    : <>
                        <div className="flex items-center justify-between gap-2">
                          <div className="text-xs text-indigo-500 font-semibold">{fmtDateOnly(e.date||e.created_at?.slice(0,10))}</div>
                          {onEdit && e.id && <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                            <button aria-label="Editar" onClick={()=>startEdit(e)} className="text-gray-300 hover:text-blue-500 text-xs">✏️</button>
                            <button onClick={()=>{if(confirm('Excluir este marco?'))onDelete(e.id);}} className="text-gray-300 hover:text-red-500 text-xs">🗑</button>
                          </div>}
                        </div>
                        <p className="text-sm text-gray-700 break-words whitespace-pre-wrap mt-0.5">{e.text}</p>
                      </>}
                </div>
              </div>
            ))}
          </div>
        </div>}
  </div>;
}

// ─── InteractionLog ───────────────────────────────────────

// Próximos passos (roadmap #8): o que está planejado para o lead.
// Diferente do Histórico (o que aconteceu) e da Linha do Tempo (marcos).
function NextStepsBlock({ tasks, isAdmin, onAdd, onToggle, onDelete }) {
  const [text, setText] = useState('');
  const [due, setDue] = useState('');
  const hoje = new Date(); hoje.setHours(0,0,0,0);
  const abertas = tasks.filter(t=>!t.done).sort((a,b)=>(a.due||'9999').localeCompare(b.due||'9999'));
  const feitas  = tasks.filter(t=>t.done);
  const prazo = (t) => {
    if (!t.due) return null;
    const diff = Math.round((new Date(t.due+'T00:00:00') - hoje) / 86400000);
    if (diff < 0)   return { cls:'bg-red-50 text-red-600',       label:`${Math.abs(diff)}d atraso` };
    if (diff === 0) return { cls:'bg-orange-50 text-orange-600', label:'hoje' };
    return               { cls:'bg-gray-100 text-gray-500',     label:fmtDateOnly(t.due) };
  };
  const submit = (e) => { e.preventDefault(); if (!text.trim()) return; onAdd({ text: text.trim(), due: due || null }); setText(''); setDue(''); };
  return <div className="rounded-2xl border border-black/[0.06] p-3">
    <div className="flex items-center justify-between mb-2">
      <span className="text-sm font-semibold text-gray-800">📌 Próximos passos</span>
      <span className="t-caption-2 text-gray-400">{abertas.length} aberta{abertas.length===1?'':'s'}</span>
    </div>
    {abertas.length===0 && feitas.length===0 && <p className="text-xs text-gray-400 italic mb-2">Nada planejado ainda.</p>}
    <div className="space-y-1">
      {abertas.map(t => { const s = prazo(t); return <div key={t.id} className="flex items-center gap-2 group">
        <button type="button" onClick={()=>onToggle(t.id)} aria-label="Concluir" className="w-5 h-5 rounded-full border-2 border-gray-300 hover:border-green-500 hover:bg-green-50 flex-shrink-0 transition-colors" />
        <span className="text-sm text-gray-700 flex-1 min-w-0 truncate">{t.text}</span>
        {s && <span className={`t-caption-2 px-1.5 py-0.5 rounded-full font-medium ${s.cls}`}>{s.label}</span>}
        {isAdmin && <button type="button" onClick={()=>onDelete(t.id)} aria-label="Excluir" className="text-gray-300 hover:text-red-500 text-xs opacity-0 group-hover:opacity-100 transition-opacity">🗑</button>}
      </div>; })}
      {feitas.map(t => <div key={t.id} className="flex items-center gap-2 opacity-50">
        <button type="button" onClick={()=>onToggle(t.id)} aria-label="Reabrir" className="w-5 h-5 rounded-full bg-green-500 border-2 border-green-500 text-white text-xs flex items-center justify-center flex-shrink-0">✓</button>
        <span className="text-sm text-gray-500 line-through flex-1 min-w-0 truncate">{t.text}</span>
      </div>)}
    </div>
    {isAdmin && <form onSubmit={submit} className="flex gap-1.5 mt-2">
      <input className="apple-input flex-1 px-3 py-1.5 text-xs" placeholder="Próximo passo..." value={text} onChange={e=>setText(e.target.value)} />
      <input type="date" className="apple-input px-2 py-1.5 text-xs w-36" value={due} onChange={e=>setDue(e.target.value)} aria-label="Prazo" />
      <button type="submit" disabled={!text.trim()} className="bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold px-3 py-1.5 rounded-xl disabled:opacity-40">+</button>
    </form>}
  </div>;
}

// WhatsApp com a mensagem já escrita (roadmap #3): escolhe o modelo e abre.
function WhatsAppMenu({ wa, lead, company }) {
  const [open, setOpen] = useState(false);
  const nossa = rotuloEmpresa(company);
  return <div className="relative inline-block">
    <button type="button" onClick={()=>setOpen(o=>!o)} aria-expanded={open}
      className="inline-flex items-center gap-1 bg-green-500 hover:bg-green-600 text-white text-xs font-medium px-2 py-0.5 rounded-full transition-colors">
      {WA_ICON} WhatsApp <span aria-hidden="true" className="opacity-70">▾</span>
    </button>
    {open && <>
      <div className="fixed inset-0 z-30" onClick={()=>setOpen(false)} />
      <div className="absolute left-0 top-full mt-1 z-40 bg-white border border-gray-200 rounded-2xl shadow-xl p-1.5 w-72 animate-fade-in-up">
        {WA_TEMPLATES.map(t => { const msg = renderWaTemplate(t.text, lead, nossa); return (
          <a key={t.key} href={waLink(wa, msg)} target="_blank" rel="noopener noreferrer" onClick={()=>setOpen(false)}
            className="block px-3 py-1.5 rounded-xl hover:bg-green-50 text-gray-700">
            <span className="text-xs font-semibold">{t.label}</span>
            <span className="block t-caption-2 text-gray-400 truncate">{msg}</span>
          </a>); })}
        <a href={waLink(wa)} target="_blank" rel="noopener noreferrer" onClick={()=>setOpen(false)}
          className="block px-3 py-1.5 rounded-xl text-xs text-gray-400 hover:bg-gray-50">Abrir sem mensagem</a>
      </div>
    </>}
  </div>;
}

function InteractionLog({ interactions, onAdd, onEdit, onDelete }) {
  // Mais recente primeiro, independente da ordem gravada (app e MCP gravam em ordens diferentes)
  const ordenadas = [...(interactions||[])].sort((a,b) => (b.created_at||b.date||'') > (a.created_at||a.date||'') ? 1 : -1);
  const [form, setForm] = useState({ type:'whatsapp', note:'', date:new Date().toISOString().slice(0,10) });
  const [adding, setAdding] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({ type:'whatsapp', note:'', date:'' });
  const icons = { ligacao:'📞', email:'📧', reuniao:'🤝', whatsapp:'💬', outro:'📝' };

  const handleAdd = e => {
    e.preventDefault();
    onAdd(form);
    setForm({ type:'whatsapp', note:'', date:new Date().toISOString().slice(0,10) });
    setAdding(false);
  };

  const startEdit = i => {
    setEditingId(i.id);
    setEditForm({ type: i.type||'ligacao', note: i.note||'', date: i.date||'' });
  };

  const handleSaveEdit = e => {
    e.preventDefault();
    onEdit(editingId, editForm);
    setEditingId(null);
  };

  return <div>
    <div className="flex items-center justify-between mb-3">
      <h3 className="text-sm font-semibold text-gray-700">Histórico de Interações</h3>
      <button onClick={()=>setAdding(a=>!a)} className="text-xs bg-blue-50 text-blue-600 px-3 py-1 rounded-full hover:bg-blue-100">+ Adicionar</button>
    </div>
    {adding && <form onSubmit={handleAdd} className="bg-gray-50 rounded-2xl p-3 mb-3 space-y-2">
      <div className="grid grid-cols-2 gap-2">
        <select className="apple-input px-2 py-1.5 text-sm" value={form.type} onChange={e=>setForm(f=>({...f,type:e.target.value}))}>
          {INTERACTION_TYPES.map(t=><option key={t} value={t}>{icons[t]} {t}</option>)}
        </select>
        <input type="date" className="apple-input px-2 py-1.5 text-sm" value={form.date} onChange={e=>setForm(f=>({...f,date:e.target.value}))} />
      </div>
      <textarea required className="apple-input w-full px-2 py-1.5 text-sm" rows={2} placeholder="Descrição..." value={form.note} onChange={e=>setForm(f=>({...f,note:e.target.value}))} />
      <div className="flex gap-2">
        <button type="submit" className="bg-blue-500 text-white text-xs px-3 py-1.5 rounded-full hover:bg-blue-600 font-semibold">Salvar</button>
        <button type="button" onClick={()=>setAdding(false)} className="bg-gray-100 text-gray-600 text-xs px-3 py-1.5 rounded-full hover:bg-gray-200 font-semibold">Cancelar</button>
      </div>
    </form>}
    {(!interactions||interactions.length===0)
      ? <p className="text-xs text-gray-400 text-center py-4">Nenhuma interação registrada</p>
      : <div className="space-y-2 max-h-60 overflow-y-auto pr-1">
          {ordenadas.map((i,idx)=>(
            <div key={i.id||idx} className="group flex gap-2 bg-gray-50 rounded-xl p-2.5">
              <span className="text-lg flex-shrink-0">{icons[i.type]||'📝'}</span>
              <div className="flex-1 min-w-0">
                {editingId===i.id
                  ? <form onSubmit={handleSaveEdit} className="space-y-1.5">
                      <div className="grid grid-cols-2 gap-1">
                        <select className="apple-input px-2 py-1 text-xs" value={editForm.type} onChange={e=>setEditForm(f=>({...f,type:e.target.value}))}>
                          {INTERACTION_TYPES.map(t=><option key={t} value={t}>{icons[t]} {t}</option>)}
                        </select>
                        <input type="date" className="apple-input px-2 py-1 text-xs" value={editForm.date} onChange={e=>setEditForm(f=>({...f,date:e.target.value}))} />
                      </div>
                      <textarea rows={2} className="apple-input w-full px-2 py-1 text-sm" value={editForm.note} onChange={e=>setEditForm(f=>({...f,note:e.target.value}))} />
                      <div className="flex gap-1">
                        <button type="submit" className="text-xs bg-blue-500 text-white px-2 py-1 rounded-full hover:bg-blue-600 font-semibold">Salvar</button>
                        <button type="button" onClick={()=>setEditingId(null)} className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full hover:bg-gray-200 font-semibold">Cancelar</button>
                      </div>
                    </form>
                  : <>
                      <div className="flex items-center justify-between gap-2">
                        <div className="flex items-center gap-2 flex-wrap">
                          <span className="text-xs font-semibold text-gray-600 capitalize">{i.type}</span>
                          <span className="text-xs text-gray-400">{fmtDateOnly(i.date)}</span>
                        </div>
                        {onEdit && i.id && <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0">
                          <button aria-label="Editar" onClick={()=>startEdit(i)} className="text-gray-300 hover:text-blue-500 text-xs">✏️</button>
                          <button onClick={()=>{if(confirm('Excluir esta interação?'))onDelete(i.id);}} className="text-gray-300 hover:text-red-500 text-xs">🗑</button>
                        </div>}
                      </div>
                      <p className="text-xs text-gray-700 mt-0.5 break-words">{i.note}</p>
                    </>}
              </div>
            </div>
          ))}
        </div>}
  </div>;
}

// ─── LeadDetailModal ──────────────────────────────────────

export { DealBoard, InteractionLog, LeadDetailModal, TimelineLog };
